<!-- Language Dropdown Selector -->
<div class="bhashini-plugin-container position-relative" title="">

  <!-- Selected language -->
  <button
    type="button"
    class="language-dropdown form-select text-start bhashini-skip-translation position-relative"
    [style.width.px]="dropdownWidth"
    [disabled]="isBhashiniLoading"
    (click)="toggleLanguageDropdown()"
    (keydown)="onLanguageDropdownKeydown($event)"
    [attr.aria-expanded]="isLanguageDropdownOpen"
    aria-haspopup="listbox"
    aria-controls="bhashini-language-list"
  >
    {{ selectedLanguageName }}

    @if (isBhashiniLoading) {
      <span class="bhashini-loader" aria-label="Loading" role="status">
        @for (line of loaderLines; track $index) {
          <span
            class="bhashini-loader-line"
            [style.transform]="'rotate(' + ($index * 30) + 'deg)'"
          ></span>
        }
      </span>
    }
  </button>

  <!-- Hidden native select for Bhashini -->
  <select
    class="bhashini-native-select bhashini-skip-translation"
    [(ngModel)]="currentLanguage"
    (change)="onLanguageChange($any($event.target).value)"
    aria-hidden="true"
    tabindex="-1"
  >
    @for (language of languages; track language.code) {
      <option [value]="language.code">
        {{ language.name }}
      </option>
    }
  </select>

  <!-- Width measurement -->
  <span
    #languageWidthMeasure
    class="language-width-measure"
    aria-hidden="true"
  >
    {{ selectedLanguageName }}
  </span>

  <!-- Custom dropdown -->
  @if (isLanguageDropdownOpen) {
    <div
      class="dropdown-menu show position-absolute top-100 end-0 p-0 mt-1 shadow border rounded bhashini-custom-dropdown"
      [style.width.px]="dropdownWidth"
    >

      <!-- Language Search -->
    <div
  class="px-2 border-bottom bg-white bhashini-skip-translation"
  style="padding-top: 2px; padding-bottom: 4px;"
>
  <div class="position-relative">

    <img
      src="images/search.svg"
      height="24"
      width="24"
      alt="Search"
      class="position-absolute top-50 translate-middle-y ms-3"
    />

    <input
      #languageSearchInput
      type="text"
      class="form-control text-sm"
      style="
        height: 36px !important;
        min-height: 36px !important;
        padding-left: 3.1rem !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      "
      placeholder="Search language"
      aria-label="Search language"
      [(ngModel)]="languageSearchText"
      autocomplete="off"
      (click)="$event.stopPropagation()"
      (keydown)="onLanguageSearchKeydown($event)"
    />

  </div>
</div>

      <!-- Languages -->
      <div
        id="bhashini-language-list"
        class="bhashini-language-options overflow-auto bhashini-skip-translation"
        role="listbox"
      >

        @for (
          language of filteredLanguages;
          track language.code;
          let i = $index
        ) {
          <button
            #languageOption
            type="button"
            class="dropdown-item text-nowrap py-2"
            role="option"
            [attr.tabindex]="highlightedLanguageIndex === i ? 0 : -1"
            [attr.aria-selected]="currentLanguage === language.code"
            [class.active]="currentLanguage === language.code"
            (click)="selectLanguage(language)"
            (keydown)="onLanguageOptionKeydown($event, i)"
          >
            {{ language.name }}
          </button>
        }

        @if (filteredLanguages.length === 0) {
          <div
            class="px-3 py-2 text-muted small bhashini-skip-translation"
          >
            No language found
          </div>
        }

      </div>

      <!-- Bhashini footer -->
      <div
        class="bhashini-branding border-top bg-white"
      >
        <div
          class="bhashini-branding-content d-flex align-items-center justify-content-start"
        >

          <!-- Feedback -->
          <button
            type="button"
            class="bhashini-feedback-button btn btn-sm p-0 border-0 bg-transparent bhashini-skip-translation"
            title="Feedback"
            aria-label="Feedback"
            (click)="openBhashiniFeedback()"
          >
            <img
              [src]="BHASHINI_FEEDBACK_ICON_URL"
              alt="Feedback"
              width="18"
              height="18"
            />
          </button>

          <span
            class="small text-dark text-nowrap bhashini-skip-translation"
          >
            Powered by
          </span>

          <!-- Bhashini logo -->
          <img
            [src]="BHASHINI_LOGO_URL"
            alt="Bhashini Logo"
            height="22"
            class="w-auto flex-shrink-0"
          />

        </div>
      </div>

      <!-- Language Feedback -->
      <app-language-feedback
        #languageFeedback
        [currentLanguage]="currentLanguage"
        (submitted)="onLanguageFeedbackSubmitted($event)"
      ></app-language-feedback>

    </div>
  }

</div>